// extracted by mini-css-extract-plugin
export default {"labelFloat":"fieldLabel_labelFloat__jWoxk","error":"fieldLabel_error__ctC6P"};